import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NcLoadingIcon = _resolveComponent("NcLoadingIcon")
  const _component_IconPhoneDialOutline = _resolveComponent("IconPhoneDialOutline")
  const _component_IconPhoneOutline = _resolveComponent("IconPhoneOutline")
  const _component_IconPhone = _resolveComponent("IconPhone")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_IconPhoneHangupOutline = _resolveComponent("IconPhoneHangupOutline")
  const _component_IconChevronUp = _resolveComponent("IconChevronUp")
  const _component_IconArrowLeft = _resolveComponent("IconArrowLeft")
  const _component_NcActionButton = _resolveComponent("NcActionButton")
  const _component_IconPhoneOffOutline = _resolveComponent("IconPhoneOffOutline")
  const _component_NcActions = _resolveComponent("NcActions")

  return ($options.showStartCallButton)
    ? (_openBlock(), _createBlock(_component_NcButton, {
        key: 0,
        title: $options.startCallTitle,
        "aria-label": $options.startCallLabel,
        disabled: $options.startCallButtonDisabled || $data.loading || $options.isJoiningCall,
        class: "join-call",
        variant: $options.hasCall ? 'success' : 'primary',
        onClick: $options.handleClick
      }, _createSlots({
        icon: _withCtx(() => [
          ($options.isJoiningCall || $data.loading)
            ? (_openBlock(), _createBlock(_component_NcLoadingIcon, {
                key: 0,
                size: 20
              }))
            : ($options.isPhoneRoom)
              ? (_openBlock(), _createBlock(_component_IconPhoneDialOutline, {
                  key: 1,
                  size: 20
                }))
              : ($props.silentCall)
                ? (_openBlock(), _createBlock(_component_IconPhoneOutline, {
                    key: 2,
                    size: 20
                  }))
                : (_openBlock(), _createBlock(_component_IconPhone, {
                    key: 3,
                    size: 20
                  }))
        ]),
        _: 2
      }, [
        ($options.showButtonText)
          ? {
              name: "default",
              fn: _withCtx(() => [
                _createTextVNode(_toDisplayString($options.startCallLabel), 1)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["title", "aria-label", "disabled", "variant", "onClick"]))
    : ($options.showLeaveCallButton && $options.canEndForAll && $options.isPhoneRoom)
      ? (_openBlock(), _createBlock(_component_NcButton, {
          key: 1,
          "aria-label": $options.endCallLabel,
          class: "leave-call",
          variant: "error",
          disabled: $data.loading,
          onClick: _cache[0] || (_cache[0] = $event => ($options.leaveCall(true)))
        }, _createSlots({
          icon: _withCtx(() => [
            ($data.loading)
              ? (_openBlock(), _createBlock(_component_NcLoadingIcon, {
                  key: 0,
                  size: 20
                }))
              : (_openBlock(), _createBlock(_component_IconPhoneHangupOutline, {
                  key: 1,
                  size: 20
                }))
          ]),
          _: 2
        }, [
          ($options.showButtonText)
            ? {
                name: "default",
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString($options.endCallLabel), 1)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["aria-label", "disabled"]))
      : ($options.showLeaveCallButton && !$options.canEndForAll && !$options.isBreakoutRoom)
        ? (_openBlock(), _createBlock(_component_NcButton, {
            key: 2,
            "aria-label": $options.leaveCallLabel,
            class: "leave-call",
            variant: $props.isScreensharing ? 'tertiary' : 'error',
            disabled: $data.loading,
            onClick: _cache[1] || (_cache[1] = $event => ($options.leaveCall(false)))
          }, _createSlots({
            icon: _withCtx(() => [
              ($data.loading)
                ? (_openBlock(), _createBlock(_component_NcLoadingIcon, {
                    key: 0,
                    size: 20
                  }))
                : (_openBlock(), _createBlock(_component_IconPhoneHangupOutline, {
                    key: 1,
                    size: 20
                  }))
            ]),
            _: 2
          }, [
            ($options.showButtonText)
              ? {
                  name: "default",
                  fn: _withCtx(() => [
                    _createTextVNode(_toDisplayString($options.leaveCallLabel), 1)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["aria-label", "variant", "disabled"]))
        : ($options.showLeaveCallButton && ($options.canEndForAll || $options.isBreakoutRoom))
          ? (_openBlock(), _createBlock(_component_NcActions, {
              key: 3,
              class: "leave-call leave-call-actions--split",
              disabled: $data.loading,
              "force-name": "",
              placement: "top-end",
              "aria-label": $options.leaveCallActionsLabel,
              inline: 1,
              variant: $options.leaveCallButtonVariant
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_IconChevronUp, { size: 20 })
              ]),
              default: _withCtx(() => [
                ($options.isBreakoutRoom)
                  ? (_openBlock(), _createBlock(_component_NcActionButton, {
                      key: 0,
                      onClick: $options.switchToParentRoom
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_IconArrowLeft, {
                          class: "bidirectional-icon",
                          size: 20
                        })
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString($options.backToMainRoomLabel), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_NcActionButton, {
                  class: "leave-call-button--split",
                  onClick: _cache[2] || (_cache[2] = $event => ($options.leaveCall(false)))
                }, {
                  icon: _withCtx(() => [
                    ($data.loading)
                      ? (_openBlock(), _createBlock(_component_NcLoadingIcon, {
                          key: 0,
                          size: 20
                        }))
                      : (_openBlock(), _createBlock(_component_IconPhoneHangupOutline, {
                          key: 1,
                          size: 20
                        }))
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString($options.leaveCallLabel), 1)
                  ]),
                  _: 1
                }),
                ($options.canEndForAll)
                  ? (_openBlock(), _createBlock(_component_NcActionButton, {
                      key: 1,
                      onClick: _cache[3] || (_cache[3] = $event => ($options.leaveCall(true)))
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_IconPhoneOffOutline, { size: 20 })
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString($options.t('spreed', 'End call for everyone')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["disabled", "aria-label", "variant"]))
          : _createCommentVNode("", true)
}